import {startCase} from "lodash"
import {ProgramPerformanceItem} from "../../ProgramPerformanceItemCard/types"
import {IcomoonIconName} from "../../Icon/icons"
import {NavigateFunction} from "react-router/dist/lib/hooks"

export type PerformanceKey = "customers" | "accounts" | "depositBalance"

type ItemConfig = {
	key: PerformanceKey
	icon: IcomoonIconName
	formatAsCurrency?: boolean
}

const performanceConfigs: ItemConfig[] = [
	{key: "customers", icon: "user-geometric-action-money-fund---users"},
	{key: "accounts", icon: "bank-account--business-products"},
	{key: "depositBalance", icon: "payment-box-reserve", formatAsCurrency: true},
]

export type GetPerformanceItemsOptions = {
	/** Keys to omit from the card (e.g. hide total balance for some roles). */
	excludeKeys?: PerformanceKey[]
}

export const getPerformanceItems = (
	valuesMap: Record<PerformanceKey, string>,
	navigate?: NavigateFunction,
	options?: GetPerformanceItemsOptions
): ProgramPerformanceItem[] =>
	performanceConfigs
		.filter((cfg) => !options?.excludeKeys?.includes(cfg.key))
		.map((cfg) => {
			const item: ProgramPerformanceItem = {
				title: startCase(cfg.key),
				icon: cfg.icon,
				...(cfg.formatAsCurrency && {formatAsCurrency: true}),
				value: valuesMap[cfg.key],
			}

			if (navigate) {
				if (cfg.key === "customers") {
					item.onClick = () => navigate("/managed-solutions/customers")
				} else if (cfg.key === "accounts") {
					item.onClick = () => navigate("/managed-solutions/accounts")
				}
			}

			return item
		})
